import { useState } from 'react';

const portfolioItems = [
  {
    id: 1,
    title: '產品特效',
    category: '動態特效',
    duration: '2:34',
    videoId: 'nX6_m99BBvw',
  },
  {
    id: 2,
    title: '建商招商廣告',
    category: 'AI製作',
    duration: '3:12',
    videoId: 'Fv3Kup3Mtwc',
  },
  {
    id: 3,
    title: '行動電源廣告',
    category: 'AI製作人物與環境',
    duration: '4:05',
    videoId: '5UH-hXtIyl0',
  },
];

export default function Portfolio() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const itemsPerPage = 3;

  const nextSlide = () => {
    setCurrentIndex((prev) =>
      prev + itemsPerPage >= portfolioItems.length ? 0 : prev + itemsPerPage
    );
  };

  const prevSlide = () => {
    setCurrentIndex((prev) =>
      prev === 0 ? Math.max(0, portfolioItems.length - itemsPerPage) : prev - itemsPerPage
    );
  };

  const visibleItems = portfolioItems.slice(currentIndex, currentIndex + itemsPerPage);

  return (
    <>
      <section id="portfolio" className="relative py-32 px-8 bg-gradient-to-b from-black via-amber-950/10 to-black">
        <div className="max-w-7xl mx-auto">
          <div className="mb-16">
            <div className="flex items-center gap-4 mb-6">
              <div className="w-12 h-px bg-gradient-to-r from-amber-400 to-transparent" />
              <span className="text-amber-400/80 text-xs tracking-[0.4em] font-light uppercase" style={{ fontFamily: "'Noto Sans TC', sans-serif" }}>SELECTED WORKS</span>
            </div>
            <h2
              className="text-8xl font-black leading-none"
              style={{
                fontFamily: "'Noto Serif TC', serif",
                background: 'linear-gradient(135deg, #fbbf24 0%, #f59e0b 40%, #fde68a 70%, #d97706 100%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text',
                filter: 'drop-shadow(0 0 30px rgba(251,191,36,0.3))',
              }}
            >
              精選
              <br />
              作品集
            </h2>
          </div>

          <div className="relative">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              {visibleItems.map((item) => (
                <div
                  key={item.id}
                  className="group relative rounded-lg overflow-hidden border border-amber-500/20 hover:border-amber-400/60 transition-all duration-500 hover:scale-105 hover:shadow-2xl hover:shadow-amber-500/30"
                >
                  {/* 自動播放影片 */}
                  <div className="relative aspect-[3/2] overflow-hidden bg-black">
                    <iframe
                      src={`https://www.youtube.com/embed/${item.videoId}?autoplay=1&mute=1&loop=1&playlist=${item.videoId}&controls=0&rel=0&modestbranding=1&playsinline=1`}
                      title={item.title}
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      className="absolute inset-0 w-full h-full object-cover pointer-events-none"
                      style={{ border: 'none' }}
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent" />
                  </div>

                  <div className="p-6 bg-gradient-to-b from-black/80 to-black backdrop-blur-sm">
                    <h3
                      className="text-2xl font-bold text-white mb-2"
                      style={{ fontFamily: "'Noto Serif TC', serif" }}
                    >
                      {item.title}
                    </h3>
                    <div className="flex items-center justify-between">
                      <span
                        className="inline-block px-4 py-1.5 bg-amber-500/10 rounded-sm text-xs text-amber-400 border border-amber-500/30 tracking-widest"
                        style={{ fontFamily: "'Noto Sans TC', sans-serif" }}
                      >
                        {item.category}
                      </span>
                      <span className="text-amber-400/50 text-xs flex items-center gap-1" style={{ fontFamily: "'Noto Sans TC', sans-serif" }}>
                        <i className="ri-movie-line text-sm" />
                        {item.duration}
                      </span>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <button
              onClick={prevSlide}
              className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-16 w-12 h-12 flex items-center justify-center rounded-full bg-black/60 backdrop-blur-sm border border-amber-500/30 hover:border-amber-400 hover:bg-amber-500/10 transition-all duration-300 hover:scale-110 cursor-pointer"
              aria-label="上一組"
            >
              <i className="ri-arrow-left-s-line text-2xl text-amber-400" />
            </button>

            <button
              onClick={nextSlide}
              className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-16 w-12 h-12 flex items-center justify-center rounded-full bg-black/60 backdrop-blur-sm border border-amber-500/30 hover:border-amber-400 hover:bg-amber-500/10 transition-all duration-300 hover:scale-110 cursor-pointer"
              aria-label="下一組"
            >
              <i className="ri-arrow-right-s-line text-2xl text-amber-400" />
            </button>
          </div>

          <div className="flex justify-center gap-2 mt-12">
            {Array.from({ length: Math.ceil(portfolioItems.length / itemsPerPage) }).map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentIndex(index * itemsPerPage)}
                className={`h-1 rounded-full transition-all duration-300 cursor-pointer ${
                  Math.floor(currentIndex / itemsPerPage) === index
                    ? 'bg-amber-400 w-8'
                    : 'bg-white/20 hover:bg-amber-400/40 w-3'
                }`}
                aria-label={`前往第 ${index + 1} 組`}
              />
            ))}
          </div>
        </div>
      </section>

    </>
  );
}
